import { atom } from 'nanostores';

export class HeaderStore {
  $isBurgerVisible = atom(false);

  $isCompaniesOpened = atom(false);

  $isUsersCasesOpened = atom(false);

  store;

  constructor(store) {
    this.store = store;
  }

  openBurgerMenu = () => {
    this.$isBurgerVisible.set(true);
    this.store.scrollStore.lock('burger');
  };

  closeBurgerMenu = () => {
    this.$isBurgerVisible.set(false);
    this.store.scrollStore.unlock('burger');
  };

  openCompanies = () => {
    this.closeUsersCases();
    this.$isCompaniesOpened.set(true);
  };

  closeCompanies = () => {
    this.$isCompaniesOpened.set(false);
  };

  openUsersCases = () => {
    this.closeCompanies();
    this.$isUsersCasesOpened.set(true);
  };

  closeUsersCases = () => {
    this.$isUsersCasesOpened.set(false);
  };

  closeAll = () => {
    this.closeUsersCases();
    this.closeCompanies();
  };
}
